import type { Locale } from "@/types";
import { createSitePathURL } from "./createSitePathURL";

export function createLocalizedSitePathURL(
  sitePath: string,
  locale: Locale,
  primaryLocale: Locale,
  url: string | string[] = [],
) {
  const localeSegment = locale === primaryLocale ? "" : locale;
  const restSegments = Array.isArray(url) ? url : [url];

  return createSitePathURL(sitePath, [localeSegment, ...restSegments]);
}
